/**
 * @generated SignedSource<<5629fe74f3bc0236eadcc77b580559c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButton_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_item">;
  readonly " $fragmentType": "PdpSharedShoppingButton_item";
};
export type PdpSharedShoppingButton_item$key = {
  readonly " $data"?: PdpSharedShoppingButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAddItemToCart_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0ef2f1afbd2fb24c27c14ddc0e536041";

export default node;
